import { AppShell, Box, Modal, Group, ThemeIcon, Text, ActionIcon } from "@mantine/core";
import { useDisclosure } from '@mantine/hooks';
import { IconRobot, IconX } from '@tabler/icons-react';

import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import SEO from "../layout/SEO";
import CyberBackground from "../landing/CyberBackground";
import Hero from "../landing/Hero";
import Features from "../info/Features";
import FAQ from "../info/FAQ";
import HowItWorks from "../info/HowItWorks";
import Comparison from "../info/Comparison";
import PreFooter from "../landing/PreFooter";

import SetupWizard from '../../bot/BotSetupWizard';
import LiveDashboard from '../../bot/BotLiveDashboard';
import { useBotSettings } from '../../bot/BotContext';
import { BotFloatingStatus } from "../../bot/BotFloatingStatus";
import { COLORS } from '../../config/constants';
import { HOME_CONTENT } from '../../data/homeContent';

/**
 * Home page component that serves as the main landing page of the application.
 * It integrates various sections like Hero, Features, HowItWorks, FAQ, and the Bot Management modal.
 */
export default function Home() {
    const [opened, { open, close }] = useDisclosure(false);
    const { setupStep } = useBotSettings();

    return (
        <AppShell header={{ height: 0 }}>
            <AppShell.Header withBorder={false} zIndex={100} style={{ background: 'transparent' }}>
                <SEO />
                <Navbar onOpen={open} />
            </AppShell.Header>

            <AppShell.Main component={"main"} pt={0}>
                <CyberBackground>
                    <Hero onLaunch={open} />
                </CyberBackground>

                <Box bg="dark.9" style={{ borderTop: '1px solid #222', borderBottom: '1px solid #222' }}>
                    <Features />
                </Box>

                <Box bg="dark.8">
                     <HowItWorks />
                </Box>

                <Box bg="dark.9" style={{ borderTop: '1px solid #222' }}>
                    <Comparison />
                </Box>

                <Box bg="dark.8">
                    <FAQ />
                </Box>

                <Box bg="dark.9">
                    <PreFooter onOpen={open} />
                </Box>

                <Footer />
            </AppShell.Main>

            <BotFloatingStatus openModal={open} isModalOpen={opened} />

            <Modal
                opened={opened}
                onClose={close}
                size="lg"
                padding={0}
                radius="lg"
                withCloseButton={false}
                closeOnClickOutside={false}
                zIndex={200}
                overlayProps={{ backgroundOpacity: 0.55, blur: 5 }}
            >
                <Box bg="dark.7" p="md" style={{ borderBottom: '1px solid var(--mantine-color-dark-4)' }}>
                    <Group justify="space-between">
                        <Group>
                            <ThemeIcon size="lg" radius="md" variant="gradient" gradient={{ from: COLORS.INDIGO, to: COLORS.CYAN }}>
                                <IconRobot size={20} />
                            </ThemeIcon>
                            <Text fw={700} size="lg" c="white">{HOME_CONTENT.modal.botDashboard}</Text>
                        </Group>
                        <ActionIcon variant="subtle" color="gray" onClick={close}><IconX size={20} /></ActionIcon>
                    </Group>
                </Box>
                <Box p={0} bg="dark.7">
                    {setupStep < 3 ? <SetupWizard /> : <LiveDashboard />}
                </Box>
            </Modal>
        </AppShell>
    );
}